module.exports = __webpack_public_path__ + "img/collect.943364fd.png";